// extracted by mini-css-extract-plugin
module.exports = {"under_search_text":"styles_under_search_text__1N6Kf","h1":"styles_h1__1LZWB","h2":"styles_h2__-lbC2","h3":"styles_h3__NoaBt","content_page":"styles_content_page__2AfY4"};